import { Injectable } from "@angular/core";
import { NetworkService } from "../../shared/network.service";


@Injectable()
export class UserMgmtService {
  constructor(private _networkService: NetworkService) {}

  getUserListApi(query) {
    return this._networkService.get(
      "api/user/userList?" + query,
      null,
      null,
      "bearer"
    );
  }
  updateUserStatus(user: any) {
    return this._networkService.put("api/user", user, null, "bearer");
  }
  getStateIdList() {
    return this._networkService.get("api/general/state",null,null,'bearer')
  }
  verifyUser(body:any){
    return this._networkService.post("api/user/verify",body,null,'bearer')
  }
  saveUser(body:any) {
    return this._networkService.post("api/user",body,null,'bearer')
  }
  getUserByStatus() {
    return this._networkService.get("api/dashboard/userByStatus",null,null,'bearer')
  }
  getOperatorByStatus() {
    return this._networkService.get("api/dashboard/operatorByStatus",null,null,'bearer')
  }
  getRsoByStatus() {
    return this._networkService.get("api/dashboard/rsosByStatus",null,null,'bearer')
  }
  getMonthlyPassenger() {
    return this._networkService.get("api/dashboard/monthlyPassengerCount",null,null,'bearer')
  }
  getMonthlyOperatorPassenger() {
    return this._networkService.get("api/dashboard/operator/monthlyPassengerCount",null,null,'bearer')
  }
  getMonthlystatePassenger() {
    return this._networkService.get("api/dashboard/monthlyStatePassengerCount",null,null,'bearer')
  }

  getmonthlyStatePassengerCountByOP() {
    return this._networkService.get("api/dashboard/operator/monthlyStatePassengerCount",null,null,'bearer')
  }
  getInvoiceDetails() {
    return this._networkService.get("api/dashboard/invoice",null,null,'bearer')
  }
  getRecentLoginUser() {
    return this._networkService.get("api/dashboard/recentLoggedIn/users",null,null,'bearer')
  } 
  getmonthlyUsersCount() {
    return this._networkService.get("api/dashboard/monthlyUsersCount/",null,null,'bearer')
  }
  getfeedByOperatorCount(id:any) {
    return this._networkService.get("api/dashboard/fleet?",null,null,'bearer')
  }
  getDriverByStaus() {
    return this._networkService.get("api/dashboard/driverByStatus/",null,null,'bearer')
  }
  getMonltytripBystate() {
    return this._networkService.get("api/dashboard/monthlyTripCount/?",null,null,'bearer')
  }

  getOperator(){
    return this._networkService.get("api/operator?status=active",null,null,'bearer')
  }
  getUserByRole(){
    return this._networkService.get("api/dashboard/userByRole",null,null,'bearer')
  }
  getAuditLogsListApi(userId:any) {
    return this._networkService.get("api/user/auditLog/"+userId,null,null,'bearer')
  }
  resetPassword(request:any) {
    return this._networkService.post("api/user/password/reset", request, null, "bearer");
  }
}
